import React from 'react';
import withTheme from '../../hocs/withTheme';
import './TabbedNavigation.css';

function TabbedNavigation({ children = null }) {
    return (
        <div className="Tabbed-navigation">
            {children}
        </div>
    );
}


export default withTheme(TabbedNavigation);
